import React from 'react'
import PropTypes from 'prop-types'
import _map from 'lodash/map'

// PropTypes
import {
  columns as columnsPropTypes,
} from './propTypes'

// Components
import FilterInput from './FilterInput'

// Styles
import {
  filtersStyle,
  checkboxStyle,
  dataRowStyle,
} from './styles'

// Exports
export const TableFilters = ({columns, filters, onFilter}) => (
  <div data-test='TableFilters' style={filtersStyle}>
    <div style={checkboxStyle} />
    <div style={dataRowStyle}>
      {_map(columns, ({attr, type, width, allowFiltering=true}, index) => {
        const value = filters[attr] != null ? filters[attr] : ''

        if (allowFiltering) {
          return (
            <FilterInput
              key={attr}
              attr={attr}
              type={type}
              width={width}
              value={value}
              onFilter={function (e) {
                onFilter({
                  attr,
                  value: e.target.value,
                })
              }}
            />
          )
        }
        let styleObj = {
          flex: `0 0 ${width}%`,
        }
        return <div
          key={attr}
          style={styleObj}
        />
      }
    )}
    </div>
  </div>
)

TableFilters.propTypes = {
  columns: columnsPropTypes,
  filters: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default TableFilters
